import { ScreenScrapeLogin } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeLogin';
import { ScreenScrapeAuthorize } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeAuthorize';
import { ScreenScrapeChooseAccount } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeChooseAccount';
import { ScreenScrapeProcessing } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeProcessing';
import { ScreenScrapeError } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeError';
import { ScreenScrapeLogout } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeLogout';
import { MessageCode } from 'src/common/models/message';
import { useSSContext } from 'src/pages/AspspSelectPage/ScreenScrape/useSSContext';
import { ScreenScrapeImageIds } from 'src/pages/AspspSelectPage/ScreenScrape/ScreenScrapeImageIds';
import { ScreenScrapeCode } from 'src/pages/AspspSelectPage/ScreenScrape/common/ScreenScrapeCode';
import { ScreenScrapeAmlPopup } from './ScreenScrapeAmlPopup';
import { TransactionsConfirmationPopup } from './TransactionsConfirmationPopup';

export const ScreenScrapeStepContent = () => {
  const ctx = useSSContext();

  // Displaying Login as first view while we're waiting for the first message from websocket
  if (
    !ctx.isUserReturningToProcess &&
    (!ctx.isFirstMessageReceived ||
      ctx.lastJsonMessage?.messageCode === MessageCode.Login)
  ) {
    return <ScreenScrapeLogin />;
  }

  switch (ctx.lastJsonMessage?.messageCode) {
    case MessageCode.Login:
      return <ScreenScrapeLogin />;
    case MessageCode.ImageIds:
      return <ScreenScrapeImageIds />;
    case MessageCode.Login2faPush:
      return <ScreenScrapeAuthorize />;
    case MessageCode.AuthorizeOperationPush:
      return <ScreenScrapeAuthorize />;
    case MessageCode.RetryAuthorizeOperationPush:
      return <ScreenScrapeAuthorize />;
    case MessageCode.AuthorizeOperationCardCode:
      return <ScreenScrapeCode />;
    case MessageCode.AuthorizeOperationSms:
      return <ScreenScrapeCode />;
    case MessageCode.ChooseAccount:
      return <ScreenScrapeChooseAccount />;
    case MessageCode.DownloadingUserInformation:
      return <ScreenScrapeProcessing />;
    case MessageCode.DownloadingTransactions:
      return <ScreenScrapeProcessing />;
    case MessageCode.Logout:
      return <ScreenScrapeLogout />;
    case MessageCode.Error:
      return <ScreenScrapeError />;
    case MessageCode.AmlPopup:
      return <ScreenScrapeAmlPopup />;
    case MessageCode.ConfirmTransactionDownload:
      return <TransactionsConfirmationPopup />;
    default:
      return null;
  }
};
